// removed by extract-text-webpack-plugin
module.exports = {"containerModal":"styles__containerModal___3Rzuf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalAutoServices/styles.css
// module id = 2864
// module chunks = 0